<div class="page-container">
	<div class="floating-tab-container">
		<h1 class="contenedorData">{{ "title.admin.home" | translate }}</h1>
		<div class="container-fluid">
			<div class="contenedorData">
				<div class="profile-container">
					<img
						[src]="photo"
						class="img-responsive profile-image"
						alt=""
					/>
					<div class="profile-content">
						<mat-form-field class="example-full-width">
							<mat-label
								>{{ "admin.adminUser" | translate }}</mat-label
							>
							<input
								type="text"
								placeholder="Nombre del administrador"
								aria-label="Número"
								matInput
								class="dataInput"
								[formControl]="adminControl"
								[matAutocomplete]="autoAdmin"
								#nombreInput
							/>
							<cdk-virtual-scroll-viewport
								class="autocomplete-test-viewport"
								itemSize="50"
								minBufferPx="500"
								maxBufferPx="750"
							>
								<mat-autocomplete
									#autoAdmin="matAutocomplete"
									[displayWith]="displayFn"
									(optionSelected)="onOptionSelected($event)"
								>
									<mat-option
										*cdkVirtualFor="let option of adminFilter"
										[value]="option"
										class="autocomplete-item"
									>
										{{option.nombre}}
									</mat-option>
								</mat-autocomplete>
							</cdk-virtual-scroll-viewport>
						</mat-form-field>
					</div>
				</div>
			</div>
			<div *ngIf="admin" class="isAdmin">
				<div class="row contenedorData">
					<mat-label class="paddingLabelBottom"
						>{{ "admin.adminTitle" | translate }}</mat-label
					>
					<div class="col-md-3">
						<mat-label class="checkBoxPanel paddingLabel"
							>{{ "admin.adminRead" | translate }}</mat-label
						>
						<mat-slide-toggle
							[checked]="admin?.usuarioAdministradorViewModel.lectura"
							color="warn"
							(change)="onReadChange($event)"
						>
						</mat-slide-toggle>
					</div>
					<div class="col-md-3">
						<mat-label class="checkBoxPanel paddingLabel"
							>{{ "admin.adminEditContrato" | translate
							}}</mat-label
						>
						<mat-slide-toggle
							[checked]="admin?.usuarioAdministradorViewModel.edicionContrato"
							color="warn"
							(change)="onEditContratoChange($event)"
						>
						</mat-slide-toggle>
					</div>
					<div class="col-md-3">
						<mat-label class="checkBoxPanel paddingLabel"
							>{{ "admin.adminEditCenter" | translate
							}}</mat-label
						>
						<mat-slide-toggle
							[checked]="admin?.usuarioAdministradorViewModel.edicionCentro"
							color="warn"
							(change)="onEditCenterChange($event)"
						>
						</mat-slide-toggle>
					</div>
					<div class="col-md-3">
						<button
							class="marginButton"
							type="submit"
							mat-raised-button
							color="warn"
							(click)="applyChanges()"
						>
							{{ "admin.apply" | translate }}
						</button>
						<button
							class="marginButton"
							mat-raised-button
							color="warn"
							(click)="exportToExcel($event, admin?.usuarioId)"
						>
							{{ "admin.summary" | translate }}
						</button>
					</div>
				</div>

				<div class="row contenedorData">
					<div class="col-md-6 table-content">
						<mat-label class="paddingLabelBottom table-title"
							>{{ "admin.adminActivityTitle" | translate
							}}</mat-label
						>
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsAc">
								<ng-container matColumnDef="filtro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
										[attr.colspan]="4"
									>
										<input
											type="text"
											[placeholder]="'admin.filter' | translate"
											matInput
											class="dataInput"
											(keyup)="applyFilter($event, 'actividad')"
											(focus)="setupFilter('actividad')"
										/>
									</th>
								</ng-container>

								<ng-container matColumnDef="actividad">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminTableDescription" |
										translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										{{ row.actividad }}
									</td>
								</ng-container>

								<ng-container matColumnDef="lectura">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminRead" | translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.lectura"
											(change)="row.lectura = !row.lectura"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionContrato">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditContrato" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Contrato"
											(change)="onEditContratoChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionCentro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditCenter" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Centro"
											(change)="onEditCenterChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<tr
									mat-header-row
									*matHeaderRowDef="['filtro']; sticky: true"
								></tr>
								<tr
									mat-header-row
									*matHeaderRowDef="['actividad', 'lectura', 'edicionContrato', 'edicionCentro']; sticky: true"
								></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: ['actividad', 'lectura', 'edicionContrato', 'edicionCentro']"
								></tr>
							</table>
						</div>
					</div>
					<div class="col-md-6 table-content">
						<mat-label class="paddingLabelBottom table-title"
							>{{ "admin.adminContratoTitle" | translate
							}}</mat-label
						>
						<div class="table-container">
							<table
								mat-table
								[dataSource]="dataSourceUsContrato"
							>
								<ng-container matColumnDef="filtro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
										[attr.colspan]="4"
									>
										<input
											type="text"
											[placeholder]="'admin.filter' | translate"
											matInput
											class="dataInput"
											(keyup)="applyFilter($event, 'contrato')"
											(focus)="setupFilter('contrato')"
										/>
									</th>
								</ng-container>

								<ng-container matColumnDef="contrato">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminTableDescription" |
										translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										{{ row.contrato }}
									</td>
								</ng-container>

								<ng-container matColumnDef="lectura">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminRead" | translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.lectura"
											(change)="row.lectura = !row.lectura"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionContrato">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditContrato" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Contrato"
											(change)="onEditContratoChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionCentro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditCenter" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Centro"
											(change)="onEditCenterChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<tr
									mat-header-row
									*matHeaderRowDef="['filtro']; sticky: true"
								></tr>
								<tr
									mat-header-row
									*matHeaderRowDef="['contrato', 'lectura', 'edicionContrato', 'edicionCentro']; sticky: true"
								></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: ['contrato', 'lectura', 'edicionContrato', 'edicionCentro']"
								></tr>
							</table>
						</div>
					</div>
				</div>

				<div class="row contenedorData">
					<div class="col-md-6 table-content">
						<mat-label class="paddingLabelBottom table-title"
							>{{ "admin.adminZoneTitle" | translate }}</mat-label
						>
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsZone">
								<ng-container matColumnDef="filtro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
										[attr.colspan]="4"
									>
										<input
											type="text"
											[placeholder]="'admin.filter' | translate"
											matInput
											class="dataInput"
											(keyup)="applyFilter($event, 'zonaSociedad')"
											(focus)="setupFilter('zonaSociedad')"
										/>
									</th>
								</ng-container>

								<ng-container matColumnDef="zonaSociedad">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminTableDescription" |
										translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										{{ row.zonaSociedad }}
									</td>
								</ng-container>

								<ng-container matColumnDef="lectura">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminRead" | translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.lectura"
											(change)="row.lectura = !row.lectura"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionContrato">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditContrato" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Contrato"
											(change)="onEditContratoChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionCentro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditCenter" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Centro"
											(change)="onEditCenterChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<tr
									mat-header-row
									*matHeaderRowDef="['filtro']; sticky: true"
								></tr>
								<tr
									mat-header-row
									*matHeaderRowDef="['zonaSociedad', 'lectura', 'edicionContrato', 'edicionCentro']; sticky: true"
								></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: ['zonaSociedad', 'lectura', 'edicionContrato', 'edicionCentro']"
								></tr>
							</table>
						</div>
					</div>
					<div class="col-md-6">
						<mat-label class="paddingLabelBottom table-title"
							>{{ "admin.adminCenterTitle" |
							translate}}</mat-label
						>
						<div class="table-container">
							<table mat-table [dataSource]="dataSourceUsCenter">
								<ng-container matColumnDef="filtro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
										[attr.colspan]="4"
									>
										<input
											type="text"
											[placeholder]="'admin.filter' | translate"
											matInput
											class="dataInput"
											(keyup)="applyFilter($event, 'centro')"
											(focus)="setupFilter('centro')"
										/>
									</th>
								</ng-container>

								<ng-container matColumnDef="centro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminTableDescription" |
										translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										{{ row.centro }}
									</td>
								</ng-container>

								<ng-container matColumnDef="lectura">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminRead" | translate }}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.lectura"
											(change)="row.lectura = !row.lectura"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="edicionCentro">
									<th
										mat-header-cell
										*matHeaderCellDef
										class="mat-header-cell"
									>
										{{ "admin.adminEditCenter" | translate
										}}
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.edicion_Centro"
											(change)="onEditCenterChangeRow(row)"
										></mat-slide-toggle>
									</td>
								</ng-container>

								<tr
									mat-header-row
									*matHeaderRowDef="['filtro']; sticky: true"
								></tr>
								<tr
									mat-header-row
									*matHeaderRowDef="['centro', 'lectura', 'edicionCentro']; sticky: true"
								></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: ['centro', 'lectura', 'edicionCentro']"
								></tr>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
